import NestedMenuItem from "../../utility/NestedMenuItem";
import {LabelOff} from "@mui/icons-material";
import {selectProject} from "../../redux/selectors/editor";
import {selectConstants, selectTags} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {Constants, Tags} from "../graph/StateTags";
import {MenuItem} from "@mui/material";
import {useContext} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";

interface IRemoveNodeTagTypeMenuItem {
    constants: Constants
    onClose: () => void
    parentOpen: boolean
    project: string
    selection: string[]
    tags: Tags
}
function RemoveNodeTagTypeMenuItem({constants, onClose, parentOpen, project, selection, tags}: IRemoveNodeTagTypeMenuItem) {
    const { remove } = useContext(FirebaseContext);
    const tagTypes: {[type:string]: string[]} = {};
    const handleSelectTag = (type: string) => () => {
        const types = tagTypes[type];

        Promise.all(types.map(type =>
            remove(type).catch(console.error)
        )).then(onClose);
    };

    selection.forEach(state =>
        Object.entries(tags[state] || {}).forEach(([key, tag]) => {
            if (tagTypes[tag.type] === undefined) {
                tagTypes[tag.type] = [];
            }
            tagTypes[tag.type].push(`tags/${project}/${state}/${key}`);
        }));
    return (
        <NestedMenuItem parentOpen={parentOpen} label={
            <><LabelOff fontSize="small" sx={{marginRight: 1}}/>Remove Node Tag Type</>
        }>
            {Object.keys(tagTypes).map(type =>
                <MenuItem key={type} value={type} onClick={handleSelectTag(type)}>{constants[type].name}</MenuItem>
            )}
        </NestedMenuItem>
    );
}

const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    constants: selectConstants(store) || {},
    tags: selectTags(store)
});
const connected = connect(mapStateToProps, {
})(RemoveNodeTagTypeMenuItem);

export {connected as RemoveNodeTagTypeMenuItem}